function AvatarCommand() {
  return 'Made with VueJS, Vuex and <3 by Julien Usson';
}

export default AvatarCommand;



// WEBPACK FOOTER //
// ./src/commands/AboutCommand.js